export default __webpack_public_path__ + "static/media/axion-today-light.e673ce64.png";